// extracted by mini-css-extract-plugin
export default {"conitaner":"UserSkins_conitaner__3q6as","main-container":"UserSkins_main-container__lnxrV","main-container_profile":"UserSkins_main-container_profile__+vHhm"};